import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/button';

const AvisoLegalPage = () => {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-300">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Link to="/">
          <Button variant="ghost" className="mb-6 text-zinc-400 hover:text-white">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Volver
          </Button>
        </Link>

        <h1 className="text-3xl font-bold text-white mb-2">Aviso Legal</h1>
        <p className="text-sm text-zinc-500 mb-8">Última actualización: 19 de febrero de 2026</p>

        <div className="prose prose-invert prose-zinc max-w-none space-y-8">
          
          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              I. Información General
            </h2>
            <p>
              En cumplimiento con el deber de información dispuesto en la Ley 34/2002, de 11 de julio, 
              de Servicios de la Sociedad de la Información y el Comercio Electrónico (LSSI-CE), 
              se facilitan a continuación los siguientes datos de información general:
            </p>
            <ul className="list-none space-y-2 mt-4 bg-zinc-900/50 p-4 rounded-lg">
              <li><strong className="text-zinc-200">Titular:</strong> Jesús María Aguado Bonill</li>
              <li><strong className="text-zinc-200">NIF:</strong> 45300927N</li>
              <li><strong className="text-zinc-200">Domicilio:</strong> Avenida de España 3, 51001 Ceuta (España)</li>
              <li><strong className="text-zinc-200">Email:</strong> jagubon@icloud.com</li>
              <li><strong className="text-zinc-200">Dominios:</strong> guardiansfit.com | app.guardiansfit.com</li>
              <li><strong className="text-zinc-200">Nombre comercial:</strong> GUARDIÁNSFIT</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              II. Objeto
            </h2>
            <p>
              El presente Aviso Legal regula el acceso y uso del Sitio Web y la Plataforma GUARDIÁNSFIT 
              (aplicación web progresiva PWA y futura app móvil) de planificación, seguimiento y 
              progresión físico-mental para usuarios finales, entrenadores y centros deportivos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              III. Uso Correcto de la Plataforma
            </h2>
            <p>
              El Usuario se compromete a utilizar GUARDIÁNSFIT conforme a la legalidad, la buena fe, 
              la moral y el orden público, quedando expresamente prohibido:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>La manipulación de métricas físicas o datos de rendimiento.</li>
              <li>La suplantación de identidad de cualquier persona usuaria o entrenadora.</li>
              <li>La introducción o difusión de contenidos ofensivos, discriminatorios o inapropiados.</li>
              <li>El uso fraudulento de la plataforma para obtener beneficios indebidos o alterar resultados.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              IV. Propiedad Intelectual
            </h2>
            <p>
              Todo el software, diseño, logotipos, contenido educativo y demás elementos de GUARDIÁNSFIT 
              están protegidos por la normativa de propiedad intelectual e industrial.
            </p>
            <p className="mt-4">
              El Usuario obtiene únicamente una licencia de uso personal, limitada, revocable y no exclusiva 
              sobre la plataforma, quedando prohibida la reproducción, distribución, comunicación pública, 
              transformación o cualquier otra forma de explotación no autorizada.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              V. Exclusión de Garantías
            </h2>
            <p>
              No se garantiza la disponibilidad ininterrumpida del Sitio Web y de la Plataforma, 
              ni la ausencia de interrupciones, errores o fallos de acceso.
            </p>
            <p className="mt-4">
              El titular no será responsable de los daños o perjuicios que puedan derivarse de caídas 
              del servicio, errores técnicos, virus u otros elementos lesivos que puedan producir 
              alteraciones en los sistemas informáticos del Usuario.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              VI. Legislación y Jurisdicción
            </h2>
            <p>
              La relación entre el titular y los usuarios del Sitio Web y de la Plataforma se regirá 
              por la normativa vigente en España.
            </p>
            <p className="mt-4">
              Las partes se someten, con renuncia expresa a cualquier otro fuero que pudiera corresponderles, 
              a los Juzgados y Tribunales de Ceuta, salvo disposición imperativa en contrario.
            </p>
          </section>

        </div>

        <div className="mt-12 pt-8 border-t border-zinc-800">
          <p className="text-sm text-zinc-500 text-center">
            © 2026 GUARDIÁNSFIT - Todos los derechos reservados
          </p>
        </div>
      </div>
    </div>
  );
};

export default AvisoLegalPage;
